// extracted by mini-css-extract-plugin
export default {"btn":"lf881gMUqJwSWmvX245F","btnActive":"ksF3KqIZwBs8fZ03Bsrz","badgeHaloSpin":"FTmERrvqV0Cz4Dc5UKDc","switch":"F5WJg5GiIH4PTacEQZGB","label":"J3hilpbh3iwROAeatU47"};